<template>
    <div class="flex justify-between">
        <Link
            :href="
                route('frontend.podcast.show', {
                    podcast: podcast.id,
                })
            "
            class="text font-semibold hover:cursor-pointer hover:text-primary-500"
        >
            {{ podcast.title }}
        </Link>

        <div
            class="hidden whitespace-nowrap text-[16px] text-gray-600 lg:block"
        >
            {{
                dayjs(podcast.updated_at)
                    .utc(true)
                    .tz($page.props.display_timezone)
                    .format($page.props.date_formats.short_nice)
            }}
        </div>
    </div>
    <div class="my-4 flex gap-4">
        <div class="text-[16px] text-gray-600">
            <media-duration
                format="short"
                :duration-in-seconds="podcast.duration"
            />
        </div>
        <div class="flex gap-2 text-[16px]">
            <span
                v-for="category in podcast.categories"
                class="rounded bg-gray-100 p-2 py-1 text-gray-700"
            >
                {{ category.title }}
            </span>
        </div>
    </div>
    <div class="mb-4 text-[16px] leading-loose text-gray-800">
        {{ podcast.excerpt }}
    </div>
    <div class="flex items-center gap-4 py-2 text-[16px]">
        <podcast-player :podcast="podcast" />

        <a
            :href="
                'https://content.jwplatform.com/videos/' +
                podcast.token +
                '-tsPSRrTH.aac'
            "
            class="flex items-center gap-2 rounded rounded-full px-3 py-2 text-primary-500 hover:cursor-pointer hover:text-primary-400"
        >
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clip-path="url(#clip0_1721_5336)">
                    <path
                        d="M6.66699 14.168L10.0003 17.5013L13.3337 14.168"
                        stroke="#2475C7"
                        stroke-width="1.66667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M10 10V17.5"
                        stroke="#2475C7"
                        stroke-width="1.66667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M17.4003 15.0769C18.1248 14.5674 18.6681 13.8404 18.9514 13.0012C19.2347 12.162 19.2431 11.2544 18.9756 10.4101C18.7081 9.56576 18.1785 8.82864 17.4637 8.3057C16.7489 7.78276 15.886 7.5012 15.0003 7.5019H13.9503C13.6997 6.52512 13.2307 5.61794 12.5787 4.84863C11.9268 4.07932 11.1088 3.46795 10.1863 3.06053C9.26387 2.6531 8.26101 2.46025 7.25325 2.49649C6.24548 2.53274 5.25907 2.79712 4.36827 3.26975C3.47747 3.74238 2.7055 4.41094 2.11047 5.22509C1.51544 6.03924 1.11285 6.97777 0.933028 7.97002C0.753202 8.96227 0.800819 9.98239 1.07229 10.9536C1.34377 11.9248 1.83203 12.8217 2.50031 13.5769"
                        stroke="#2475C7"
                        stroke-width="1.66667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1721_5336">
                        <rect width="20" height="20" fill="white" />
                    </clipPath>
                </defs>
            </svg>

            <span>Download</span>
        </a>
        <div class="-my-2 h-12 border-l border-gray-200">&nbsp;</div>
        <Link
            :href="route('frontend.podcast.show', { podcast: podcast.id })"
            class="text-gray-600 underline hover:cursor-pointer hover:text-primary-400"
        >
            See notes
        </Link>
    </div>
</template>
<script>
import MediaDuration from "@/Components/MediaDuration";
import PodcastPlayer from "@/Components/PodcastPlayer";

export default {
    name: "PodcastExcerptLink",
    components: { PodcastPlayer, MediaDuration },
    props: {
        podcast: {},
    },
};
</script>
